import './tariffComp.css'
import { useLocation } from 'react-router-dom'

export function TariffCard({details}){
    const location = useLocation()
    const path = location.pathname.substring(1)
    return(
        <div className='card'>
            <p className='catagory'>{details.catagory}</p>
            <p className='cars'>{details.car}</p>
            <figure>
                <img src={`./images/${details.image}.png`} alt={details.image}/>
            </figure>
            <main>
                <h2>{details.round}</h2>
                <p>/per km</p>
            </main>
            <aside>
                <p>{"Round"}</p>
                <ul>
                    {details.one?<li>One-Way Trip - {details.one}/km</li>:null}
                    <li>Driver Allowance - {details.allowance}</li>
                    <li>Toll and Parking Extra</li>
                </ul>
            </aside>
            <a href={path===""?'#book':"/"} className='Btn cardBtn'>Book Now</a>
        </div>
    )
}
export default function TariffComp(){

    const tariff=[{
        catagory:"Sedan",
        car:"Etios, Dzire",
        image:'sedan',
        one:'Rs.15',
        round:'Rs.13',
        allowance:'Rs.500'
    }, {
        catagory:"SUV",
        car:"Xylo, Tavera, Ertiga",
        image:'SUV',
        one:'Rs.19',
        round:'Rs.17',
        allowance:'Rs.500'
    }, {
        catagory:"Innova",
        car:"Assured Innova",
        image:'Innova',
        one:'Rs.20',
        round:'Rs.18',
        allowance:'Rs.500'
    }, {
        catagory:"Luxury Car",
        car:"Innova Crysta",
        image:'Crysta',
        one:false,
        round:'Rs.20',
        allowance:'Rs.700'
    }, {
        catagory:"traveller",
        car:"Tempo Traveller",
        image:'Traveller',
        one:false,
        round:'Rs.23',
        allowance:'Rs.700'
    }, {
        catagory:"Couch 21Seater",
        car:"Bus",
        image:'Bus',
        one:false,
        round:'Rs.28',
        allowance:'Rs.800'
    }, ]
    
    return(
    <div className='tariffContainer'>
        <header>
            <h3>We have flexible pricing</h3>
            <h3>Choose your taxi:</h3>
        </header>
        <article>
                <TariffCard 
                details={tariff[0]}/>
                <TariffCard
                details={tariff[1]}/>
                <TariffCard
                details={tariff[2]}/>
                <TariffCard
                details={tariff[3]}/>
                <TariffCard
                details={tariff[4]}/>
                <TariffCard
                details={tariff[5]}/>
        </article>
    </div>
    )
}